import axios from 'axios';
import configFallback from '../../config';

// require('dotenv').config();

var baseURL = '';
var appConfig = configFallback;

export const configPromise = axios.get('config.json')
    .then((response) =>
    {
        console.log('response 1', response);
        baseURL = response.data;
        appConfig = response.data;

        axios.defaults.baseURL = baseURL.AMEX_API_URL || 'https://online.americanexpress.com.sa/';
        console.log('baseURL 1', baseURL);
        return appConfig;
    })
    .catch((error) =>
    {
        axios.defaults.baseURL = 'https://online.americanexpress.com.sa/';
        console.error('Error fetching config:', error);
        return configFallback;
    });

console.log('baseURL 2', baseURL);

// axios.interceptors.request.use(config =>
// {
//   let token = localStorage.getItem('Token');
// 
//   // if (!!store.get('accounts/token')) config.headers.common.Authorization = 'Bearer ' + store.get('accounts/token');
//   if (token) config.headers.common.Authorization = 'Bearer ' + token;
// 
//   // if (!!token) config.headers = { authentication: token, language: 'ar' }
//   // config.headers = { authentication: process.env.VUE_APP_API_TOKEN }
//   return config;
// });
axios.interceptors.response.use(
    response =>
    {
        return response;
    },
    error =>
    {
        // if ('401' == error.response.status) accountServices.logout();
        // console.log(error);

        return Promise.resolve({ error });
    }
);

export default axios;
